exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-header[data-v-e7a3fa0e] {\n  padding-bottom: 0.5rem;\n}\n.clients-list[data-v-e7a3fa0e] {\n  overflow-y: scroll;\n  max-height: 50vh;\n  border: solid 1px #bfbfbf;\n}\n.client-image[data-v-e7a3fa0e] {\n  width: 64px;\n  height: 64px;\n}\n.list-item[data-v-e7a3fa0e] {\n  border-bottom: solid 1px #bfbfbf;\n}\n.list-item[data-v-e7a3fa0e]:last-of-type {\n  border-bottom: none;\n}\n.form-check-input[data-v-e7a3fa0e] {\n  margin-top: auto;\n  margin-bottom: auto;\n}", ""]);

// exports
